import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SystemMinimizeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 1.25H3C2.04 1.25 1.25 2.04 1.25 3V21C1.25 21.96 2.04 22.75 3 22.75H21C21.96 22.75 22.75 21.96 22.75 21V3C22.75 2.04 21.96 1.25 21 1.25ZM21.25 21C21.25 21.14 21.14 21.25 21 21.25H3C2.86 21.25 2.75 21.14 2.75 21V3C2.75 2.86 2.86 2.75 3 2.75H21C21.14 2.75 21.25 2.86 21.25 3V21Z"
        fill={color}
      />
      <path
        d="M17 16.25H7C6.59 16.25 6.25 16.59 6.25 17C6.25 17.41 6.59 17.75 7 17.75H17C17.41 17.75 17.75 17.41 17.75 17C17.75 16.59 17.41 16.25 17 16.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SystemMinimizeIcon.displayName = 'SystemMinimizeIcon';
